import { createContext } from 'react'

export default createContext({
  notification: undefined,
  setNotification: () => {},
})
